import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { UsersService } from './services/users.service'
import { Router, ActivatedRoute} from '@angular/router';
import { Subscription } from 'rxjs/Rx'

declare var pleaseWait: any

@Component({
    selector: 'body',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit, OnDestroy {
  isLoading = true
  authState:Subscription
  constructor(public authService:UsersService, public router: Router, public location: Location) {

  }

  ngOnInit() {
    let loading_screen = pleaseWait({
      logo: "assets/img/Logomakr_4IcGbx.png",
      backgroundColor: '#20a8d8',
      loadingHtml: `<h3 class='loading-message' style='color:#ddd;'>最先進的雲端POS管理平台</h3>
                    <div class='sk-three-bounce'>
                      <div class='sk-child sk-bounce1' style='background-color:white'></div>
                      <div class='sk-child sk-bounce2' style='background-color:white'></div>
                      <div class='sk-child sk-bounce3' style='background-color:white'></div>
                    </div>`
    })

    this.authState = this.authService.isAuthenticated().subscribe(
      authenticated => {
        console.log('app component')

        if (authenticated) {
            if (this.location.path() == "/signin") {
              this.router.navigate(["/dashboard"])
            }

        }else {
            this.router.navigate(['/signin'])
        }
        loading_screen.finish()

      }
    )

  }

  ngOnDestroy() {
    this.authState.unsubscribe()
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts